var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "div",
        { staticClass: "table" },
        [
          _c("TableHeader", {
            attrs: { columns: _vm.columns, "data-source": _vm.dataSource }
          }),
          _vm._l(_vm.dataSource.docs, function(rowData, rowIndex) {
            return _c("TableRow", {
              key: rowIndex,
              attrs: { data: rowData, columns: _vm.columns },
              on: {
                click: function($event) {
                  return _vm.onClickRow(rowData)
                }
              }
            })
          }),
          _vm.dataSource.docs.length <= 0
            ? _c("div", { staticClass: "table-row empty" }, [
                _c("div", { staticClass: "table__placeholder--icon" }),
                _c("p", { staticClass: "table__placeholder--text" }, [
                  _vm._v(_vm._s(_vm.$t("tables.emptyDataResults")))
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm.dataSource.docs.length > 0
        ? _c("TablePaginator", { attrs: { "data-source": _vm.dataSource } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }